@if (noActivatedChildren()) {
    <div class="container-fluid pb-3">
        @switch (view().status) {
            @case ('loading') {
                <app-load />
            }
            @case ('error') {
                <div class="alert alert-danger" role="alert">
                    {{ 'installationProjects_error' | translate: 'online' : 'ngonline' }}
                </div>
            }
            @case ('success') {
                <p class="text-muted">
                    {{ 'installationProjects_intro' | translate: 'online' : 'ngonline' }}
                </p>

                <div class="d-flex justify-content-between align-items-center mb-2">
                    <span class="fw-bold">
                        {{ 'installationProjects_card_title' | translate: 'online' : 'ngonline' }}
                        <span class="text-muted fw-normal">/ {{ rows().length }}</span>
                    </span>
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        [disabled]="rows().length === 0"
                        (click)="exportFilteredProjects()">
                        <i class="bi bi-file-earmark-text me-1" aria-hidden="true"></i>
                        {{ 'installationProjects_export' | translate: 'online' : 'ngonline' }}
                    </button>
                </div>

                <div class="table-responsive w-100">
                    <table class="table table-striped table-sm align-middle">
                        <thead>
                            <tr>
                                @for (column of columns; track column.column) {
                                    <th
                                        app-sortable-table-header
                                        [column]="column.column"
                                        [label]="column.labelKey | translate: 'online' : 'ngonline'"
                                        [initialDirection]="sortDirectionFor(column.column)"
                                        (sort)="onSort($event)"></th>
                                }
                                <th class="last-col"></th>
                            </tr>
                            <tr [formGroup]="filterForm">
                                @for (column of columns; track column.column) {
                                    <th class="align-top">
                                        @switch (column.filter) {
                                            @case ('text') {
                                                <app-input-text-group
                                                    [trim]="true"
                                                    [markTouchedOnChange]="false"
                                                    [formControlName]="column.column" />
                                            }
                                            @case ('status') {
                                                <app-input-dropdown-checkboxes
                                                    [formControl]="filterForm.controls.statuses" />
                                            }
                                            @case ('customerInfo') {
                                                <app-input-dropdown-checkboxes
                                                    [formControl]="
                                                        filterForm.controls.customerInformation
                                                    " />
                                            }
                                            @case ('date') {
                                                <app-input-date-group
                                                    [formControlName]="column.column" />
                                            }
                                        }
                                    </th>
                                }
                                <th class="last-col"></th>
                            </tr>
                        </thead>
                        <tbody class="text-nowrap">
                            @for (row of pagedRows(); track row.project.projectId ?? $index) {
                                <tr>
                                    <td class="fw-bold text-primary">
                                        {{ row.project.projectNumber }}
                                    </td>
                                    <td>{{ row.project.buildingNumber }}</td>
                                    <td>{{ row.project.buildingName }}</td>
                                    <td>
                                        <span class="badge" [class]="row.statusDisplay.pillClass">
                                            {{
                                                row.statusDisplay.labelKey
                                                    | translate: 'online' : 'ngonline'
                                            }}
                                        </span>
                                    </td>
                                    <td>{{ row.address }}</td>
                                    <td class="text-center">
                                        @if (row.awaitingCustomerInfo) {
                                            <i
                                                class="bi bi-exclamation-circle-fill text-warning"
                                                [title]="
                                                    'installationProjects_customerInfo_awaiting'
                                                        | translate: 'online' : 'ngonline'
                                                "></i>
                                        } @else {
                                            <i
                                                class="bi bi-check-circle-fill text-success"
                                                [title]="
                                                    'installationProjects_customerInfo_ok'
                                                        | translate: 'online' : 'ngonline'
                                                "></i>
                                        }
                                    </td>
                                    <td>
                                        @if (row.project.plannedStart; as plannedStart) {
                                            {{ plannedStart | appdate }}
                                        } @else {
                                            &ndash;
                                        }
                                    </td>
                                    <td>
                                        @if (
                                            row.project.expectedCompletion;
                                            as expectedCompletion
                                        ) {
                                            {{ expectedCompletion | appdate }}
                                        } @else {
                                            &ndash;
                                        }
                                    </td>
                                    <td class="last-col text-end">
                                        @if (row.project.projectId != null) {
                                            <a
                                                class="btn btn-link btn-sm px-0 py-0"
                                                [routerLink]="[row.project.projectId]">
                                                {{ 'common_SHOW' | translate }}
                                            </a>
                                        }
                                    </td>
                                </tr>
                            } @empty {
                                <tr>
                                    <td colspan="9" class="text-center text-muted py-4">
                                        {{ 'table_noResults' | translate: 'online' : 'common' }}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <div class="text-center">
                    <app-pagination
                        [collectionSize]="rows().length"
                        [page]="currentPage()"
                        [pageSize]="pageSize()"
                        (pageChange)="setPage($event)"
                        (pageSizeChange)="setPageSize($event)" />
                </div>
            }
        }
    </div>
}

<router-outlet />
